export default __webpack_public_path__ + "static/media/speaker-icon.9c5aeda9.svg";